
export interface IIPFilterSettings {
  blockAfterAttempts: number;
  blockForMinutes: number;
  filters: IIPFilterSettings$IIpFilter[];
}

export interface IIPFilterSettings$IIpFilter {
  ipDescription: string;
  ipFormat: string;
  neverBlock: boolean;
  rule: IpFilterRule;
}

export type IpFilterRule = 'BLOCK' | 'ALLOW_2FA' | 'ALLOW';
export const IpFilterRuleValues: IpFilterRule[] = ['BLOCK' , 'ALLOW_2FA' , 'ALLOW'];

